import { Fade } from "react-awesome-reveal";
import TestTitle from "../../testCommon/TestTitle";
import SummaryIcon from "../../../../assets/images/summary.png";
import RecommendationsImage from "../../../../assets/icons/recommendations.png";

const Recommendation = ({ testInfo, testResults, footerButtons }: any) => {
  const is_pro = testInfo.is_pro_analysis;

  const defaultText =
    " برای استفاده از این اطلاعات، لازمه که تحلیل پیشرفته رو انتخاب کنید برای این آزمایش تا هوش‌مصنوعی بادی‌بان این اطلاعات رو بهتون نمایش بده.";

  const recommendationsList = [
    {
      id: 2,
      badge: "ارزیابی کلی",
      title: ` ارزیابی بادی‌بان <br /> درباره وضعیت کلی سلامت شما:`,
      content: is_pro
        ? testResults?.medical_advice?.health_risk_assessment
        : defaultText,
    },
    {
      id: 3,
      badge: "مدیریت و بهبود",
      title: `پیشنهادهای بادی‌بان <br /> برای مدیریت و بهبود شرایط شما:`,
      content: is_pro
        ? testResults?.medical_advice?.management_and_treatment
        : defaultText,
    },
    {
      id: 4,
      badge: "دمنوش و گیاهان دارویی",
      title: `دمنوش و <br /> گیاهان دارویی پیشنهادی:`,
      content: is_pro
        ? testResults?.medical_advice?.medicinal_plants_herbal_teas
        : defaultText,
    },
    {
      id: 5,
      badge: "رژیم و سبک زندگی",
      title: `تغییرات لازم <br /> در رژیم و سبک زندگی:`,
      content: is_pro
        ? testResults?.medical_advice?.lifestyle_dietary_advice
        : defaultText,
    },
    {
      id: 6,
      badge: "آزمایش",
      title: `آزمایش‌های پیشنهادی <br /> برای ارزیابی بهتر وضعیت سلامت:`,
      content: is_pro
        ? testResults?.medical_advice?.complementary_tests
        : defaultText,
    },
    {
      id: 7,
      badge: "ویتامین",
      title: `ویتامین‌های <br /> پیشنهادی با توجه به آزمایش شما:`,
      content: is_pro
        ? testResults?.medical_advice?.useful_vitamins
        : defaultText,
    },
  ];

  return (
    <div className="flex-1">
      <Fade triggerOnce>
        <TestTitle
          title="تحلیل و پیشنهادات بادی‌بان"
          subtitle="تحلیل و پیشنهادات بادی‌بان درباره آزمایش شما"
          icon={RecommendationsImage}
        />

        <div className="flex flex-col lg:flex-row gap-2">
          <div className="w-full relative bg-white border rounded-xl p-6 lg:p-10">
            <div>
              <span className="text-xs font-rokh font-[700] bg-slate-200 rounded-lg px-3 pt-2 py-[5px]">
                هوش‌مصنوعی بادی‌بان
              </span>
              <h2 className="my-4 font-rokh text-lg lg:text-[23px] leading-normal font-[900]">
                تحلیل هوش‌مصنوعی بادی‌بان <br /> درباره آزمایش و وضعیت سلامت
                شما:
              </h2>
              <div className={`relative lg:pl-72 p-0`}>
                <div>
                  <p className="leading-7 text-right max-w-3xl text-sm">
                    {testResults?.medical_advice?.user_medical_advice}
                  </p>
                </div>
              </div>
            </div>
            <img
              className="relative hidden lg:flex lg:absolute lg:left-16 lg:top-0 h-full mx-auto"
              src={SummaryIcon}
              width={280}
              alt="ارزیابی بادی‌بان"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mt-3 lg:mt-5">
          {recommendationsList.map((recommendation) => (
            <div
              key={recommendation.id}
              className="relative flex-1 bg-white rounded-xl p-6 lg:p-8 border"
            >
              <span className="text-xs font-rokh font-[700] bg-slate-200 rounded-lg px-3 pt-2 py-[5px]">
                {recommendation.badge}
              </span>
              <h2
                className="font-rokh font-[900] mt-4"
                dangerouslySetInnerHTML={{ __html: recommendation.title }}
              ></h2>
              <div
                className={`${!is_pro && !testInfo.is_old_user ? "blur" : ""}`}
              >
                <p className="mt-4 lg:mt-8 text-sm">{recommendation.content}</p>
              </div>
            </div>
          ))}
        </div>

        {footerButtons}
      </Fade>
    </div>
  );
};

export default Recommendation;
